import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { GenericRosterComponent } from '../generic-roster/generic-roster.component';
import { StudentCardComponent } from './student-card.component';
import { School, SchoolRosterFilter, SchoolTermGradeDto, SchoolGradeYearDto, AttendanceType } from '@k12/models';
import { SchoolsService } from '@k12/school-services';
import {
  TRANSFER_WITHDRAWAL_COLUMN_DEFINITIONS,
  TRANSFER_WITHDRAWAL_DISPLAYED_COLUMNS,
  TRANSFER_WITHDRAWAL_COLUMN_TO_API_FIELD_MAP
} from '../roster-column-definitions';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-transfers-withdrawals-roster',
  template: `
    <lib-generic-roster
      [currentSchool]="currentSchool"
      [editable]="editable"
      [showAdminActions]="showAdminActions"
      [schoolTermId]="schoolTermId"
      [termName]="termName"
      [academicYearId]="academicYearId"
      [reloadTrigger]="reloadTrigger"
      [studentCardComponent]="studentCardComponent"
      [loadStudentsQuery]="loadStudentsQuery"
      [exportQuery]="exportQuery"
      [importQuery]="importQuery"
      [rosterTitle]="rosterTitle"
      [columnDefinitions]="columnDefinitions"
      [displayedColumns]="displayedColumns"
      [columnToApiFieldMap]="columnToApiFieldMap"
      [schoolTermGrades]="schoolTermGrades"
      [schoolGradeYears]="schoolGradeYears"
      [attendanceTypes]="attendanceTypes"
      [emptyStateMessage]="emptyStateMessage"
      [searchTerm]="searchTerm"
      (countChanged)="countChanged.emit($event)"
      (reverted)="reverted.emit($event)">
    </lib-generic-roster>
  `,
  standalone: true,
  imports: [GenericRosterComponent]
})
export class TransfersWithdrawalsRosterComponent {
  @Input() editable = false;
  @Input() showAdminActions = false;
  @Input() currentSchool: School | null = null;
  @Input() schoolTermId: string | null = null;
  @Input() termName: string | null = null;
  @Input() academicYearId: number | null = null;
  @Input() reloadTrigger: number = 0;
  @Input() schoolTermGrades: SchoolTermGradeDto[] = [];
  @Input() schoolGradeYears: SchoolGradeYearDto[] = [];
  @Input() attendanceTypes: AttendanceType[] = [];
  @Input() emptyStateMessage: string = 'No transfers or withdrawals found.';
  @Input() searchTerm: string = '';
  @Output() countChanged = new EventEmitter<number>();
  @Output() reverted = new EventEmitter<string>();

  get studentCardComponent() {
    return StudentCardComponent;
  }
  columnDefinitions = TRANSFER_WITHDRAWAL_COLUMN_DEFINITIONS;
  displayedColumns = TRANSFER_WITHDRAWAL_DISPLAYED_COLUMNS;
  columnToApiFieldMap = TRANSFER_WITHDRAWAL_COLUMN_TO_API_FIELD_MAP;

  private readonly schoolsService: SchoolsService = inject(SchoolsService);
  loadStudentsQuery = (filters: SchoolRosterFilter) => this.schoolsService.getTransferWithdrawalRosters(filters);
  exportQuery = (mini: boolean, schoolTermId?: string | null) =>
    this.schoolsService.exportTransferWithdrawalRoster(this.currentSchool!.programPartnerId!, mini, schoolTermId, this.academicYearId);
  importQuery = (file: File, schoolTermId?: string | null) =>
    this.schoolsService.importRoster(this.currentSchool!.programPartnerId!, file, schoolTermId);
  rosterTitle = 'Transfers & Withdrawals';
}
